import { Injectable, OnDestroy, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccessToken } from '../interfaces/user-details';
import { ApiHelperService } from './api-helper.service';
import { TimerService } from './timer-service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class UserIdentityService implements OnDestroy {
  public isLoggedIn = new BehaviorSubject(false);
  public _userDetails: any = null;
  public _userDetailsSubject = new BehaviorSubject(null);
  private jwtTimer = new TimerService(1000);
  private jwtSubscription: Subscription;
  private renderer: Renderer2;


  constructor(
    private apiHelper: ApiHelperService,
    private rendererFactory2: RendererFactory2,
    private router: Router,
    private matDialog: MatDialog) {
    this.renderer = this.rendererFactory2.createRenderer(null, null);
    this.getUserDetails();
  }

  ngOnDestroy(): void {
    this.stopJwtTimer();
  }

  getUserSubscription() {
    return this._userDetailsSubject;
  }

  getUserDetails() {
    if (this.isValidToken()) {
      this.isLoggedIn.next(true);
      this._userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
      this.startJwtTimer();
    } else {
      this._userDetails = null;
      // this.clearUserDetails();
    }
    this._userDetailsSubject.next(this._userDetails);
    return this._userDetails;
  }

  setUserDetails(user) {
    let userDetails = this.getUserDetails();
    Object.assign(userDetails, user);
    sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
  }

  get roleName() {
    return sessionStorage.getItem('roleName');
  }

  set userDetails(userDetails) {
    this._userDetails = userDetails;
  }

  get userDetails() {
    return this.getUserDetails();
  }

  isOthersDetailsSubmitted() {
    return this._userDetails && this._userDetails.isOtherDetailsSubmitted;
  }


  storeUserDetails(accessToken) {
    sessionStorage.setItem('token', accessToken.id.toString());
    sessionStorage.setItem('userId', accessToken.userId.toString());
    sessionStorage.setItem('ttl', accessToken.ttl.toString());
    sessionStorage.setItem('created', accessToken.created.toString());
    if (accessToken.userDetails) {
      sessionStorage.setItem('userDetails', JSON.stringify(accessToken.userDetails));
    }
    this.isLoggedIn.next(true);
  }

  login(credentails: any) {
    return new Promise((resolve, reject) => {
      this.apiHelper.postData("users/login", credentails).subscribe((accessToken: AccessToken) => {
        this.storeUserDetails(accessToken);
        resolve(accessToken.userDetails);
        //this.apiHelper.openSnackBar('Login Successfully!');
        this.startJwtTimer();
      }, err => {
        reject(err);
        let errMsg = err.error.error ? err.error.error.message : err.message;
        this.apiHelper.openSnackBar(errMsg, { duration: 6000 });
      });
    });
  }

  loginWithId(userId: string, rememberMe: boolean = true) {
    return new Promise((resolve, reject) => {
      this.apiHelper.postData("auth/generate-token", { userId, rememberMe }).subscribe((response: any) => {
        this.storeUserDetailsFromGenerateToken(response);
        resolve(response.user);
        this.startJwtTimer();
      }, err => {
        reject(err);
        let errMsg = err.error.error ? err.error.error.message : err.message;
        this.apiHelper.openSnackBar(errMsg, { duration: 6000 });
      });
    });
  }

  loginWithPassword(credentials: { email: string, password: string, rememberMe?: boolean }) {

    return new Promise((resolve, reject) => {
      this.apiHelper.postData("auth/login-password", credentials).subscribe((response: any) => {
        this.storeUserDetailsFromGenerateToken(response);
        resolve(response);
        this.startJwtTimer();
      }, err => {
        console.error('Frontend: Login error details:', err);
        reject(err);
        let errMsg = err.error?.message || err.message;
        this.apiHelper.openSnackBar(errMsg, { duration: 6000 });
      });
    });
  }

  loginWithLicense(licenseNumber: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiHelper.postData("auth/login-license", { licenseNumber }).subscribe((response: any) => {
        this.storeUserDetailsFromGenerateToken(response);
        resolve(response);
        this.startJwtTimer();
      }, err => {
        console.error('License login error:', err);
        reject(err);
        let errMsg = err.error?.message || err.message;
        this.apiHelper.openSnackBar(errMsg, { duration: 6000 });
      });
    });
  }




  storeUserDetailsFromGenerateToken(response: any) {
    sessionStorage.setItem('token', response.accessToken.toString());
    if (response?.ttl) {
      sessionStorage.setItem('ttl', response.ttl.toString());
    }
    if (response?.created) {
      sessionStorage.setItem('created', response.created.toString());
    }
    this.isLoggedIn.next(true);
  }




  logout() {
    // this.clearUserDetails();
    localStorage.removeItem("sound");
    localStorage.removeItem("signUpComplete");
    localStorage.removeItem("LoginComplete");
  }

  clearUserDetails() {
    this.stopJwtTimer(); // Stop timer when clearing user details
    this.userDetails = null;
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('ttl');
    sessionStorage.removeItem('created');
    sessionStorage.removeItem('userDetails');
    sessionStorage.removeItem('decodedToken');
    localStorage.removeItem("sound");
    localStorage.removeItem("signUpComplete");
    localStorage.removeItem("LoginComplete");
    localStorage.removeItem("comingFrom");
    localStorage.removeItem("visaDetails");
    localStorage.removeItem("visaCode");
    localStorage.removeItem("scenario");
    localStorage.removeItem("userNameCode");
    this.isLoggedIn.next(false);
  }


  register(userDetails: any) {
    return new Promise((resolve, reject) => {
      this.apiHelper.postData("users/verifyOtp", userDetails).subscribe((accessToken: AccessToken) => {
        this.storeUserDetails(accessToken);
        resolve(accessToken.userDetails);
        //this.apiHelper.openSnackBar('Login Successfully!');
      }, err => {
        reject(err);
        let errMsg = err.error.error ? err.error.error.message : err.message;
        this.apiHelper.openSnackBar(errMsg, { duration: 6000 });
      });
    });
  }

  quickRegister(userDetails: any) {
    return this.apiHelper.postData("users", userDetails);
  }

  isValidToken() {
    let token = sessionStorage.getItem('token')
    if (token) {
      const expiry = JSON.parse(atob(token.split('.')[1])).exp;
      const currentTime = Math.floor((new Date).getTime() / 1000);
      const isValid = currentTime <= expiry;
      return isValid;
    } else {
      return false;
    }
  }



  sendOtp(mobile: string) {
    return this.apiHelper.getData(`users/otp/${mobile}`);
  }

  verifyOtp(mobileOtp: any) {
    return this.apiHelper.postData(`/users/login-with-mobile-otp`, mobileOtp);
  }



  startJwtTimer() {
    // Stop any existing timer and subscription
    this.stopJwtTimer();

    // Start the timer
    this.jwtTimer.start();

    this.jwtSubscription = this.jwtTimer.observable$.pipe(
      map(count => {
        let isTokenValid = this.isValidToken();
        if (isTokenValid) {
          return count;
        } else {
          throw new Error("jwtExpired");
        }
      })
    ).subscribe(
      count => {
        // Token is still valid, continue
      },
      error => {
        this.stopJwtTimer();
        this.clearUserDetails();
       // this.router.navigate(['/' + "L0M1UFZ0"]);
      }
    );
  }

  private stopJwtTimer() {
    if (this.jwtSubscription) {
      this.jwtSubscription.unsubscribe();
      this.jwtSubscription = null;
    }
    this.jwtTimer.stop();
  }


  public decodeJwtToken(token: string): any {
    try {
      const payload = token.split('.')[1];
      const decodedPayload = atob(payload);
      return JSON.parse(decodedPayload);
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return null;
    }
  }

  // Debug method to check token status
  public debugTokenStatus(): void {
    const token = sessionStorage.getItem('token');
    if (token) {
      const decoded = this.decodeJwtToken(token);
      const currentTime = Math.floor(Date.now() / 1000);
      const timeLeft = decoded.exp - currentTime;
    }
  }



}
